import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { isEmpty } from 'lodash'
import { ReactComponent as AssignmentIcon } from 'assets/img/teams-icon.svg'
import { Collapse } from '@material-ui/core'
import {
  StyledCondition,
  StyledModalBoxSection,
  StyledRuleSettings,
  StyledTitle,
  StyledTitleHint,
} from 'components/common/Modals/styles'
import { BUTTON_TYPE_SECONDARY } from 'components/common/Button/constants'
import StyledButton from 'components/common/Button/Button'
import { ASSIGNMENTS } from 'constants/managementUI'
import messages from '../../../translate'
import { AssignmentProps } from './AssignmentSection.types'
import { Subtitle } from './AssignmentSection.styles'

const AssignmentSection = ({
  intl: { formatMessage },
  isOpened,
  setIsOpened,
  isDefaultAssignment,
  setIsAssignmentSubModalOpened,
  formData,
}: AssignmentProps & WrappedComponentProps) => (
  <StyledModalBoxSection>
    <Subtitle>{formatMessage(messages.additionalSettings)}</Subtitle>
    <StyledRuleSettings>
      <StyledTitle
        expandable
        opened={isOpened}
        onClick={() => setIsOpened(!isOpened)}>
        <AssignmentIcon />
        {formatMessage(messages.assignment)}
        {isDefaultAssignment && (
          <StyledTitleHint>
            {` ${formatMessage(messages.defaultAssignees)}`}
          </StyledTitleHint>
        )}
      </StyledTitle>
      <Collapse in={isOpened}>
        <StyledCondition direction="column" wrap="wrap" align="flex-start">
          <StyledButton
            onClick={() => setIsAssignmentSubModalOpened(true)}
            disabled={
              isEmpty(formData[ASSIGNMENTS]) || !formData.sitesAndUnits?.length
            }
            type={BUTTON_TYPE_SECONDARY}>
            {formatMessage(messages.editAssignees)}
          </StyledButton>
        </StyledCondition>
      </Collapse>
    </StyledRuleSettings>
  </StyledModalBoxSection>
)

export default injectIntl(AssignmentSection)
